import { createBoundContext } from '@bonusly/design-system';

interface ToggleContextValue {
	value: any;
	onChange: (value: any) => void;
}

export const [ToggleProvider, useToggleContext] = createBoundContext<ToggleContextValue>({
	hookName: 'useToggleContext',
	name: 'ToggleContext',
	providerName: 'ToggleProvider',
});
